// extracted by mini-css-extract-plugin
export default {"container":"container__tSMEr","slide_box":"slide_box__kgXR8","slide_item":"slide_item__pF+P0"};